import apiFetch from './apiFetch';
import { API_URL } from './apiClient';
import { WorkflowRuleView } from './workflowClient';

export async function fetchWorkflowSubject(
	token: string,
	subject: string
): Promise<{ managed: boolean; transitions: Record<string, string[]> | null }> {
	const res = await apiFetch(`${API_URL}/workflows/subjects/${subject}`, {
		headers: { Authorization: `Bearer ${token}` },
	});
	return res.json();
}

export async function fetchWorkflowRules(
	token: string
): Promise<WorkflowRuleView[]> {
	const res = await apiFetch(`${API_URL}/workflows`, {
		headers: { Authorization: `Bearer ${token}` },
	});
	return res.json();
}

export async function updateWorkflowRule(
	token: string,
	code: string,
	payload: Partial<
		Pick<WorkflowRuleView, 'enabled' | 'priority' | 'parameters'>
	>
): Promise<WorkflowRuleView> {
	const res = await apiFetch(
		`${API_URL}/workflows/${encodeURIComponent(code)}`,
		{
			method: 'PATCH',
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		}
	);
	return res.json();
}
